module.exports = __webpack_public_path__ + "static/media/Logo.f27f969d.svg";